export enum CrmIdEnum {
  YES = 'Has CRM ID',
  NO_ID = 'No CRM ID',
}
